function hasAttr(element: HTMLElement, find: string | string[]): boolean {
    if (typeof find === 'string') {
        find = find.split(' ');
    }

    for (const item of find) {
        if (!element.hasAttribute(item)) {
            return false;
        }
    }

    return true;
}

// ----------------------------------------------------------------------------

export default hasAttr;
